export default "__VITE_ASSET__78fb3ebf__"